import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RookeryRegularFont } from 'v3/styles/common';

export const LabelSmallStyled = styled(Typography)<TypographyProps>(() => ({
  font: `400 0.8125rem ${RookeryRegularFont}`,
}));

export const LabelSmallCustomStyled = styled(Typography)<TypographyProps>(() => ({
  font: `500 0.8225rem ${RookeryRegularFont}`,
}));

export const LabelSmallBoldStyled = styled(Typography)<TypographyProps>(() => ({
  font: `700 0.8225rem ${RookeryRegularFont}`,
}));
